import * as React from 'react'
import Switch from 'react-toggle-switch'
import {RiskLevel} from '../../../Logic/RiskComplianceStore/RiskManagement'
import {Main} from '../../../Logic/Main'
import {Logic} from '../../../Logic/Type'
import * as Config from '../../../Logic/Config'
import * as DbRoutes from '../../../Logic/Database/DbRoutes'
import * as Assets from '../../Assets'
// import * as Assets_ from '../../Assets_'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faTimes} from '@fortawesome/free-solid-svg-icons'

interface State {
    currency: 'N/A'|'CHF'|'EUR'|'USD'
    limit: number
    allowPlay: boolean
    allowDeposit: boolean
    allowWithdraw: boolean
    riskLevel: RiskLevel,
    accountSuspension: boolean
}

export default class MaxAmountWallet extends React.Component<{}, State> {
    constructor(props) {
        super(props)
        this.state = {
            currency: 'CHF',
            limit: 100,
            allowPlay: false,
            allowDeposit: false,
            allowWithdraw: false,
            riskLevel: RiskLevel.Low,
            accountSuspension: false,
        }
    }

    public Add() {
        DbRoutes.wsBasicInsert(Config.amMaximumBalance, {
            currency: this.state.currency,
            limit: this.state.limit,
            allowPlay: this.state.allowPlay,
            allowDeposit: this.state.allowDeposit,
            allowWithdraw: this.state.allowWithdraw,
            riskLevel: this.state.riskLevel,
            accountSuspension: this.state.accountSuspension,
        })
        Logic.Type.New (Main.Instance.RiskManagementState, {showAddMaxAmountWallet: false})
    }

    public render() {
        return (
            <div className = "clearfix add-setting-popup">
                <div className = "add-setting-main">
                    <div style = {{position: 'relative'}}>
                        <button style = {{position: 'absolute', top: '-20px', right: '-20px', border: '0px', background: 'transparent'}} onClick = {() => Logic.Type.New (Main.Instance.RiskManagementState, {showAddMaxAmountWallet: false})}>
                            <FontAwesomeIcon style = {{fontSize: '12px'}} icon = {faTimes}/>
                        </button>

                        <h4>{Assets.AddMaxBalanceOnPlayerWalletRules}</h4>
                        <div className = "clearfix mt5 mb">
                            <span className = "mr">{Assets.Currency}</span>
                            <button 
                                className = "btn btn-xs"
                                // onClick = {() => ''}
                            >
                                {this.state.currency}
                            </button>
                        </div>

                        <div className = "clearfix mt5 mb">
                            <div className = "fl mt2 mr">{Assets.Limit}</div>
                            <input
                                className = "input-popup pr0"
                                onChange = {(e) => this.setState({limit: +e.target.value})}
                                type = "number"
                                min = "0"
                                value = {this.state.limit}
                            />
                        </div>

                        <div className = "clearfix mt5 mb">
                            <Switch className = "fl mr" onClick = {() => this.setState({allowPlay: !this.state.allowPlay})} on = {this.state.allowPlay} />
                            <div className = "fl mt2">{Assets.AllowPlay}</div>
                        </div>

                        <div className = "clearfix mt5 mb">
                            <Switch className = "fl mr" onClick = {() => this.setState({allowDeposit: !this.state.allowDeposit})} on = {this.state.allowDeposit}/>
                            <div className = "fl mt2">{Assets.AllowDeposit}</div>
                        </div>
                        <div className = "clearfix mt5 mb">
                            <Switch className = "fl mr" onClick = {() => this.setState({allowWithdraw: !this.state.allowWithdraw})} on = {this.state.allowWithdraw}/>
                            <div className = "fl mt2">{Assets.AllowWithdraw}</div>
                        </div>

                        <div className = "mb20">
                            <span className = "mr">{Assets.RiskLevel}</span>
                            <button 
                                className = {'btn btn-xs risk risk-' + RiskLevel[this.state.riskLevel]}
                            >
                                {RiskLevel[this.state.riskLevel]}
                                <input 
                                    type = "range"
                                    list = "test"
                                    min = "1"
                                    max = "5"
                                    step = "1"
                                    defaultValue = "1"
                                    onChange = {(e) => this.setState({riskLevel: +e.target.value})}
                                    className = "slider"
                                />
                            </button>
                        </div>

                        <div className = "clearfix mt5 mb">
                            <Switch className = "fl mr" onClick = {() => this.setState({accountSuspension: !this.state.accountSuspension})} on = {this.state.accountSuspension}/>
                            <div className = "fl mt2">{Assets.AccountSuspension}</div>
                        </div>
                    </div>
                    <div>
                        <button className = "btn btn-danger btn-xs" onClick = {() => Logic.Type.New (Main.Instance.RiskManagementState, {showAddMaxAmountWallet: false})}>
                            {Assets.Cancel}
                        </button>
                        <button className = "btn btn-success btn-xs" onClick = {() => this.Add()}>
                            {Assets.Confirm}
                        </button>
                    </div>
                </div>
            </div>
        )
    }
}
